var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "document",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "document-1",
    d: "M17.9825439,0 L24,6.08862305 L24,24.5690918 L20.5,24.5050049 L20.5,28 L0.5,28 L0.5,3.5 L4,3.5 L4,0 L17.9825439,0 Z M4,5 L2,5 L2,26.5 L19,26.5 L19,24.5050049 L22.5,24.5050049 L22.5,24.5 L4,24.5 L4,5 Z M16.7,7.5 L16.7,1.5 L5.5,1.5 L5.5,23 L22.5,23 L22.5,7.5 L16.7,7.5 Z M17.988,2.14 L18,6 L21.859,6.057 L17.988,2.14 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "document-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "document-4",
    xlinkHref: "#document-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "document-5",
    className: "fill-selector",
    fill: "#151515",
    fillRule: "nonzero",
    xlinkHref: "#document-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "document-6",
    className: "fill-selector",
    width: 12,
    height: 1.5,
    x: 8,
    y: 10.5,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "document-7",
    className: "fill-selector",
    width: 12,
    height: 1.5,
    x: 8,
    y: 14,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "document-8",
    className: "fill-selector",
    width: 12,
    height: 1.5,
    x: 8,
    y: 17.5,
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.cadb3716b4953885d66bdaa72c2cd9f5.svg";
export { ForwardRef as ReactComponent };